<div class="search-bar-container">
  <div class="search-bar">
    <form [formGroup]="searchForm">
      <input
        type="search"
        [placeholder]="placeHolder || 'Search and Press Enter'"
        formControlName="searchInput"
        (keydown.enter)="onSearch($event)"
        required
      />
    </form>
    <button
      type="button"
      class="search-btn"
      [title]="
        enableBulkSearch
          ? 'Click to search. Press and hold for bulk search.'
          : 'Search'
      "
      (click)="onSearchClick()"
      (mousedown)="onSearchBtnPressStart()"
      (mouseup)="onSearchBtnPressEnd()"
      (mouseleave)="onSearchBtnPressEnd()"
      (touchstart)="onSearchBtnPressStart()"
      (touchend)="onSearchBtnPressEnd()"
      (touchcancel)="onSearchBtnPressEnd()"
    >
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>

@if (enableBulkSearch) {
  <div class="custom-container" [class.active]="showBulkSearchModal">
    <div class="custom-modal custom-modal-s">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Bulk Search</h4>
            <button
              type="button"
              class="custom-close-btn"
              (click)="closeBulkSearchModal()"
            >
              &times;
            </button>
          </div>
          <div class="custom-modal-body">
            <div class="component-container">
              <div class="component-header">
                <h6 class="component-title">Bulk Search</h6>
                <div class="component-actions">
                  <button
                    type="button"
                    class="primary-button"
                    (click)="downloadBulkSearchSampleFile()"
                  >
                    Download Sample Sheet
                    <mat-icon class="btn-icon">download </mat-icon>
                  </button>
                </div>
              </div>
              <div class="component-separator"></div>
              <div class="component-body">
                <div class="form-section">
                  <div class="form-group">
                    <label for="bulk-search-file-upload" class="form-label"
                      >Bulk Search File Upload</label
                    >
                    <mat-form-field
                      class="file-upload-container"
                      appearance="outline"
                    >
                      <mat-label>Bulk Search File Upload</mat-label>

                      <!-- Display File Name or Placeholder -->
                      <input
                        matInput
                        type="text"
                        [value]="bulkSearchFileName"
                        readonly
                      />

                      <!-- Hidden File Input -->
                      <input
                        type="file"
                        accept=".xlsx"
                        aria-label="File"
                        class="d-none"
                        (change)="onBulkFileSelected($event)"
                        #bulkFileInput
                      />

                      <!-- Custom Upload Button -->
                      <button
                        class="upload-btn"
                        (click)="bulkFileInput.click()"
                        type="button"
                      >
                        <mat-icon>attach_file</mat-icon>
                      </button>

                      @if (bulkSearchError) {
                        <mat-error>{{ bulkSearchError }}</mat-error>
                      }
                      @if (bulkSearchValues.length > 0) {
                        <div class="bulk-search-summary">
                          {{ bulkSearchValues.length }} search value(s) found.
                        </div>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="component-separator"></div>

              <div class="component-footer">
                <div class="button-group">
                  <button
                    type="button"
                    class="clear-button"
                    (click)="closeBulkSearchModal()"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="edit-button"
                    [disabled]="bulkSearchValues.length === 0"
                    (click)="onBulkSearchSubmit()"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
